<template>
  <div class="person">
    <img v-if="person.avatar" :src="person.avatar" :alt="`${person.name} ${person.lastname}`" />
    <div v-else class="avatar-placeholder" aria-hidden="true">{{ initials }}</div>
    <div class="person-data">
      <h4>{{ person.name }} {{ person.lastname }}</h4>
      <p v-if="person.responsability" class="responsability">{{ person.responsability }}</p>
      <p v-if="person.phone">Teléfono: {{ person.phone }}<span v-if="person.internal_phone"> · Int. {{ person.internal_phone }}</span></p>
      <p v-if="person.celphone">Celular: {{ person.celphone }}</p>
      <p v-if="person.email"><a :href="`mailto:${person.email}`">{{ person.email }}</a></p>
      <a class="profile-link" :href="`https://www.osfatun.com.ar/personal/${person.id}`" target="_blank" rel="noopener">
        Ver tarjeta personal <span aria-hidden="true">→</span>
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: "PublicPerson",
  props: {
    person: { type: Object, required: true },
  },
  computed: {
    initials() {
      return `${String(this.person.name || "").charAt(0)}${String(this.person.lastname || "").charAt(0)}`.toUpperCase();
    },
  },
};
</script>

<style scoped>
.person { display: flex; align-items: center; gap: 15px; }
.person img, .avatar-placeholder { flex: 0 0 74px; width: 74px; height: 74px; border-radius: 50%; object-fit: cover; }
.avatar-placeholder { display: grid; place-items: center; background: #edf6f7; color: #00758f; font-weight: 800; }
.person-data h4 { margin: 0 0 4px; color: #00758f; font-size: 17px; }
.person-data p { margin: 3px 0; font-size: 13px; line-height: 1.35; }
.person-data .responsability { color: #415c65; font-weight: 700; }
.person-data a { color: #00758f; }
.person-data .profile-link { display: inline-flex; gap: 6px; margin-top: 7px; color: #00758f; font-size: 12px; font-weight: 800; text-transform: uppercase; }
@media (max-width: 440px) { .person { align-items: flex-start; }.person img, .avatar-placeholder { flex-basis: 58px; width: 58px; height: 58px; } }
</style>
